import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
const features = ['+300 páginas', '+200 ejercicios graficados', 'Todos los niveles', 'Sistema "Abrí y Dictás"'];
export function SystemSection() {
  return <section className="py-16 px-4 bg-primary text-white" data-id="element-237">
      <div className="max-w-4xl mx-auto text-center" data-id="element-238">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-239">
          <h2 className="text-3xl md:text-5xl font-black mb-4" data-id="element-240">
            🏆 El Sistema N°1 para Instructores de Stretching Argentinos
          </h2>
          <h3 className="text-2xl md:text-3xl font-bold mb-2 text-highlight" data-id="element-241">
            STRETCHING 360 — Colección Completa
          </h3>
          <p className="text-xl mb-8 text-white/90" data-id="element-242">
            12 Tomos + 6 Bonus + 2 Élite — Todo resuelto, todos los niveles.
          </p>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-243">
            {features.map((feature, index) => <motion.div key={index} initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="bg-white/10 rounded-lg p-4 border border-white/20" data-id="element-244">
                <CheckIcon className="w-6 h-6 mx-auto mb-2 text-highlight" data-id="element-245" />
                <p className="font-semibold text-sm" data-id="element-246">{feature}</p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}